import { Money } from "@hubrise/react-components"

import { ICatalog, IOptionList, IProduct, ISku } from "../models"
import { OptionList, Sku } from "../utils"

import ItemCustomisation from "./ItemCustomisation"

class ItemSku {
  private readonly catalog: ICatalog
  private readonly product: IProduct
  private skuName: string | undefined
  private readonly customisation: ItemCustomisation

  constructor(catalog: ICatalog, product: IProduct) {
    this.catalog = catalog
    this.product = product
    const sku = product.skus[0]
    this.skuName = sku.name
    this.customisation = new ItemCustomisation(catalog, sku)
  }

  get sku(): ISku {
    return this.product.skus.find((sku) => sku.name === this.skuName) || this.product.skus[0]
  }

  get optionLists(): Array<IOptionList> {
    return OptionList.bySku(this.catalog, this.sku)
  }

  optionNames(optionListName: string): Array<string> {
    return this.customisation.optionNames(optionListName)
  }

  setSkuName(skuName: string): void {
    this.skuName = skuName
    this.customisation.setSku(this.sku)
  }

  setOptionNames(optionListName: string, optionNames: Array<string>): void {
    this.customisation.setOptionNames(optionListName, optionNames)
  }

  price(variantRef: string | null): Money {
    const skuPrice = Sku.price(this.sku, variantRef)
    return skuPrice.plus(this.customisation.price(variantRef))
  }
}

export default ItemSku
